<template>
  <nav-bar :title="name" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <!-- <div class="title">{{ name }}</div> -->
    <ul class="list" v-if="list.length">
      <li class="list-item" v-for="item in list" :key="item.userId" @click="$router.push(`/userInfo/${item.userId}`)" >
        <div class="row">
          <span>客户：</span>
          <span>{{ item.companyName }}</span>
        </div>
        <div class="row">
          <span>瓶数：</span>
          <span>{{ item.cyNum }}</span>
        </div>
        <div class="row">
          <span>联系人：</span>
          <span>{{ item.userName }}-{{ item.phoneNum }}</span>
        </div>
        <div class="row">
          <span>地址：</span>
          <span>{{ item.address }}</span>
        </div>
      </li>
    </ul>
    <Empty v-else />
  </Content>
</template>

<script>
import { ref } from 'vue'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { StatisticsCylinderInfoByRegion } from '@/api/superviseHome'
export default {
  name: 'SupervisionCylinderList',
  props: ['name', 'stId'],
  setup(props) {
    const list = ref([])
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      StatisticsCylinderInfoByRegion,
      data => {
        list.value = data || []
      },
      props.stId
    )
    getDataLoading()
    return { getDataLoading, showLoading, isLoading, list }
  }
}
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin-top: 16px;
}
.list {
  padding: 0 16px;
  margin-top: 16px;
  .list-item {
    padding: 10px;
    background-color: #fff;
    font-size: 12px;
    line-height: 24px;
    margin-bottom: 10px;
    .row {
      span:first-child {
        width: 60px;
        display: inline-block;
        color: #666;
      }
    }
  }
}
</style>
